import React, {Component} from 'react';
import {withRouteData} from 'react-static';
import styled from 'styled-components';

import FlagRU from '../resources/images/flags/ru.png';
import FlagCN from '../resources/images/flags/china.png';
import FlagIN from '../resources/images/flags/india.png';
import FlagUS from '../resources/images/flags/usa.png';
import FlagEU from '../resources/images/flags/eu.png';

const RoadmapStyle = styled.div`
	.history-content {
	    margin-top: 3.75rem;
	}
	
	.history-item {
		margin-bottom: 3.125rem;
		
		&--future {
			opacity: 0.5;
			.history-title {
				opacity: 0.5;
			}
		}
	}
	
	.history-date {
		font-weight: 700;
		font-size: 20px;
		color: #A2A2A2;
		line-height: 1.2em;
		display: inline-block;
		margin-bottom: 5px;
	}
	
	.history-icon {
		display: inline-block;
		width: 24px;
		position: relative;
		top: -3px;
		margin-left: 8px;
	}
	
	.history-title {
		margin-bottom: 3px;
		font-weight: 500;
		font-size: 0.9375rem;
		line-height: 1.33em;
		text-shadow: 0 0 10px rgba(131, 245, 248, 0.30);
	}
	
	.history-desc, .history-download {
		margin-bottom: 3px;
		font-size: 0.875rem;
		line-height: 1.29em;
		opacity: 0.5;
	}
	
	.history-download:hover {
		opacity: 1;
	}

`;

class Roadmap extends Component {

	render() {
		
		return (
			<RoadmapStyle>
				<div className="container">
					<div className="row text-center">
						<div className="columns small-centered medium-8">
							<h2>{this.props.roadmap.header}</h2>
							<p className="caption">{this.props.roadmap.caption}</p>
						</div>
					</div>
					<div className="history-content">
						<div className="row" data-equalizer>
							<div className="columns small-4 medium-4 large-2">
								<div className="history-item" data-equalizer-watch="true">
									<div className="history-date">2005</div>
									<img className="history-icon" src={ FlagRU } alt="Russian flag" />
									<div className="history-title">{ this.props.roadmap.patentRussia }</div>
								</div>
							</div>
							<div className="columns small-4 medium-4 large-2">
								<div className="history-item" data-equalizer-watch="true">
									<div className="history-date">2006</div>
									<img className="history-icon" src={ FlagIN } alt="Indian flag" />
									<div className="history-title">{ this.props.roadmap.patentIndia }</div>
									<a className="history-download" target="_blank" href="/files/patent-india.pdf">{ this.props.roadmap.downloadPDF }</a>
								</div>
							</div>
							<div className="columns small-4 medium-4 large-2">
								<div className="history-item" data-equalizer-watch="true">
									<div className="history-date">2010</div>
									<img className="history-icon" src={ FlagCN } alt="Chinese flag" />
									<div className="history-title">{ this.props.roadmap.patentChina }</div>
									<a className="history-download" target="_blank" href="/files/patent-china.pdf">{ this.props.roadmap.downloadPDF }</a>
								</div>
							</div>
							<div className="columns small-4 medium-4 large-2">
								<div className="history-item " data-equalizer-watch="true">
									<div className="history-date">2010</div>
									<img className="history-icon" src={ FlagEU } alt="European flag" />
									<div className="history-title">{ this.props.roadmap.patentEurope }</div>
									<a className="history-download" target="_blank" href="/files/patent-europe.pdf">{ this.props.roadmap.downloadPDF }</a>
								</div>
							</div>
							<div className="columns small-4 medium-4 large-2">
								<div className="history-item" data-equalizer-watch="true">
									<div className="history-date">2012</div>
									<img className="history-icon" src={ FlagUS } alt="US flag" />
									<div className="history-title">{ this.props.roadmap.patentUSA }</div>
									<a className="history-download" target="_blank" href="/files/patent-usa.pdf">{ this.props.roadmap.downloadPDF }</a>
								</div>
							</div>
							<div className="columns small-4 medium-4 large-2">
								<div className="history-item" data-equalizer-watch="true">
									<div className="history-date">2013</div>
									<img className="history-icon" src={ FlagRU } alt="Russian flag" />
									<div className="history-title">{ this.props.roadmap.developmentRussia }</div>
								</div>
							</div>
							<div className="columns small-6 medium-2 large-2">
								<div className="history-item" data-equalizer-watch="true">
									<div className="history-date">2014</div>
									<div className="history-title">{ this.props.roadmap.certifiedBellLabs }</div>
									<a className="history-download" target="_blank" href="/files/belllabs.pdf">{ this.props.roadmap.downloadPDF }</a>
								</div>
							</div>
							<div className="columns small-6 medium-2 large-2">
								<div className="history-item" data-equalizer-watch="true">
									<div className="history-date">2015</div>
									<div className="history-title">{ this.props.roadmap.finishedStandards }</div>
								</div>
							</div>
							<div className="columns small-6 medium-8 large-5">
								<div className="history-item" data-equalizer-watch="true">
									<div className="history-date">2016</div>
									<div className="history-title">{ this.props.roadmap.itu.caption }</div>
									<div className="history-desc">{ this.props.roadmap.itu.description }</div>
									<a className="history-download" target="_blank" href="/files/itu.pdf">{ this.props.roadmap.downloadPDF }</a>
								</div>
							</div>
							<div className="columns small-6 medium-4 large-3">
								<div className="history-item" data-equalizer-watch="true">
									<div className="history-date">2016</div>
									<div className="history-title">{ this.props.roadmap.sample.caption }</div>
									<div className="history-desc">{ this.props.roadmap.sample.description }</div>
								</div>
							</div>
							<div className="columns small-6 medium-4 large-4">
								<div className="history-item history-item--future" data-equalizer-watch="true">
									<div className="history-date">March 2020</div>
									<div className="history-title">{ this.props.roadmap.sets.caption }</div>
									<div className="history-desc">{ this.props.roadmap.sets.description }</div>
								</div>
							</div>
							<div className="columns small-6 medium-4 large-4">
								<div className="history-item history-item--future" data-equalizer-watch="true">
									<div className="history-date">2020</div>
									<div className="history-title">{ this.props.roadmap.newZones.caption }</div>
									<div className="history-desc">{ this.props.roadmap.newZones.description }</div>
								</div>
							</div>
							<div className="columns small-6 medium-4 large-2">
								<div className="history-item history-item--future" data-equalizer-watch="true">
									<div className="history-date">2020</div>
									<div className="history-title">{ this.props.roadmap.massProduction }</div>
								</div>
							</div>
							<div className="columns small-6 medium-4 large-2">
								<div className="history-item history-item--future" data-equalizer-watch="true">
									<div className="history-date">2021</div>
									<div className="history-title">{ this.props.roadmap.deliveriesInstallation }</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</RoadmapStyle>
		)
	}
}

export default withRouteData(Roadmap)


// WEBPACK FOOTER //
// /opt/build/repo/src/components/Roadmap.js